module.exports = __webpack_public_path__ + "img/cart-abandonment.cea8708e.svg";